<template>
    <div class="main">

        <el-tabs type="border-card" v-model="tabAtiva">
            <el-tab-pane label="FALTAS" name="0"> 
                <list-faltas></list-faltas>
            </el-tab-pane>
            <el-tab-pane label="NOTAS" name="1"> 
                <list-faltas></list-faltas>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>
<script>
import ListFaltas from './list-faltas.vue';

export default {
    data: () => ({
        tabAtiva: 0
    }),
    mounted () {
     
    },
    methods: {
        
    },
    components:{ 
        ListFaltas
    }
}
</script>